import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";

export default function Products() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ code: "", name: "", category: "", quality_class: "", unit: "adet", origin: "Yurt İçi", description: "" });

  const load = async () => setItems((await api.get("/products")).data);
  useEffect(() => { load(); }, []);

  const create = async () => {
    try { await api.post("/products", form); toast.success("Eklendi"); setOpen(false); setForm({ code: "", name: "", category: "", quality_class: "", unit: "adet", origin: "Yurt İçi", description: "" }); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Hata"); }
  };
  const del = async (id) => { if (!window.confirm("Silmek?")) return; await api.delete(`/products/${id}`); load(); };

  return (
    <div className="space-y-6" data-testid="products-page">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-xs uppercase tracking-widest text-muted-foreground">Katalog</div>
          <h2 className="font-heading text-3xl font-bold tracking-tight mt-1">Ürün Kataloğu</h2>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <Button data-testid="add-product-btn" className="bg-primary hover:bg-orange-600 text-white"><Plus size={16} className="mr-2" /> Ürün Ekle</Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>Yeni Ürün</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <Input placeholder="Kod (örn: YAT-70)" data-testid="product-code" value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} />
              <Input placeholder="Ürün Adı" data-testid="product-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
              <Input placeholder="Kategori" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} />
              <Input placeholder="Kalite/Sınıf" value={form.quality_class} onChange={(e) => setForm({ ...form, quality_class: e.target.value })} />
              <Input placeholder="Birim (adet, ton, kg, m²)" value={form.unit} onChange={(e) => setForm({ ...form, unit: e.target.value })} />
              <Input placeholder="Menşe" value={form.origin} onChange={(e) => setForm({ ...form, origin: e.target.value })} />
              <Button data-testid="save-product" onClick={create} className="w-full bg-primary hover:bg-orange-600 text-white">Kaydet</Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      <Card className="border-border overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-900 text-white text-left">
              <tr>{["Kod", "Ürün", "Kategori", "Kalite", "Birim", "Menşe", ""].map(h => <th key={h} className="px-4 py-2 font-semibold">{h}</th>)}</tr>
            </thead>
            <tbody>
              {items.map((p) => (
                <tr key={p.id} className="border-t border-border hover:bg-slate-50 dark:hover:bg-slate-800">
                  <td className="px-4 py-2 font-mono">{p.code}</td>
                  <td className="px-4 py-2">{p.name}</td>
                  <td className="px-4 py-2">{p.category}</td>
                  <td className="px-4 py-2 text-xs">{p.quality_class}</td>
                  <td className="px-4 py-2">{p.unit}</td>
                  <td className="px-4 py-2">{p.origin}</td>
                  <td className="px-4 py-2 text-right"><Button size="sm" variant="ghost" onClick={() => del(p.id)}><Trash2 size={14} className="text-destructive" /></Button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
